import { FormGroup } from 'shared-components';
import * as yup from 'yup';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';
import styles from './product.module.css';
import { useCreateProductMutation } from './products.api';
import { Button } from 'shared-components';
import { useAppDispatch } from '../../app/hooks';
import { close } from '../modal/modalSlice';
import {
  DeliveryMechanism,
  IProduct,
  ProductScope,
} from '@topshots/core-models';
import { FormLayout } from 'shared-components';
import { Label } from 'shared-components';
import { Input } from 'shared-components';
import { TextArea } from 'shared-components';
import { Select } from 'shared-components';
import { Checkbox } from 'shared-components';

export const CreateProduct = ({ addOnFor }: { addOnFor?: string }) => {
  const dispatch = useAppDispatch();

  const [create] = useCreateProductMutation();
  const { handleSubmit, getFieldProps, errors, values } = useFormik<
    Partial<IProduct>
  >({
    initialValues: {
      scope: ProductScope.Image,
      addOnFor: addOnFor ?? '',
      name: '',
      description: '',
      price: 0,
      shippingCost: 0,
      deliveryMechanism: DeliveryMechanism.Post,
      imagesRequired: 1,
      isInstantDownload: false,
      lengthLongSide: 0,
    },
    enableReinitialize: true,
    validationSchema: yup.object({
      name: yup.string().required(),
      description: yup.string(),
      price: yup.number().required(),
      shippingCost: yup.number().required(),
      scope: yup.mixed<ProductScope>().oneOf(Object.values(ProductScope)),
      deliveryMechanism: yup
        .mixed<DeliveryMechanism>()
        .oneOf(Object.values(DeliveryMechanism)),
      imagesRequired: yup.number().required(),
      isInstantDownload: yup.boolean().required(),
      lengthLongSide: yup.number().required(),
    }),
    onSubmit: async (values) => {
      await create(values);
      toast.success('Product created!', {
        autoClose: 2000,
      });
      dispatch(close());
    },
  });
  return (
    <form onSubmit={handleSubmit}>
      <FormLayout className={styles.createProductForm}>
        <FormGroup>
          <Label htmlFor="scope">Scope</Label>
          <Select {...getFieldProps('scope')} id="scope">
            <option value={ProductScope.Image}>Image</option>
            <option value={ProductScope.Event}>Event</option>
          </Select>
          {errors.scope && <span>{errors.scope}</span>}
        </FormGroup>
        <FormGroup>
          <Label htmlFor="name">Name</Label>
          <Input {...getFieldProps('name')} type="text" id="name" />
          {errors.name && <span>{errors.name}</span>}
        </FormGroup>
        <FormGroup>
          <Label htmlFor="description">Description</Label>
          <TextArea
            {...getFieldProps('description')}
            cols={30}
            rows={10}
            id="description"
          />
          {errors.description && <span>{errors.description}</span>}
        </FormGroup>
        <FormGroup>
          <Label htmlFor="price">Price</Label>
          <Input {...getFieldProps('price')} type="number" id="price" />
          {errors.price && <span>{errors.price}</span>}
        </FormGroup>
        <FormGroup>
          <Label htmlFor="shippingCost">Shipping cost</Label>
          <Input
            {...getFieldProps('shippingCost')}
            type="number"
            id="shippingCost"
          />
          {errors.shippingCost && <span>{errors.shippingCost}</span>}
        </FormGroup>
        <FormGroup>
          <Label htmlFor="deliveryMechanism">Delivery mechanism</Label>
          <Select
            {...getFieldProps('deliveryMechanism')}
            id="deliveryMechanism"
          >
            <option value={DeliveryMechanism.Email}>Email</option>
            <option value={DeliveryMechanism.Post}>Post</option>
          </Select>
          {errors.deliveryMechanism && <span>{errors.deliveryMechanism}</span>}
        </FormGroup>
        {values.scope === ProductScope.Image && (
          <>
            <FormGroup>
              <Label htmlFor="imagesRequired">Images required</Label>
              <Input
                {...getFieldProps('imagesRequired')}
                type="number"
                id="imagesRequired"
              />
              {errors.imagesRequired && <span>{errors.imagesRequired}</span>}
            </FormGroup>
            <FormGroup>
              <Checkbox
                label="Instant download"
                type="checkbox"
                id="instantDownload"
                defaultChecked={false}
                {...getFieldProps('isInstantDownload')}
              />

              {errors.isInstantDownload && (
                <span>{errors.isInstantDownload}</span>
              )}
            </FormGroup>

            {values.isInstantDownload && (
              <FormGroup>
                <Label htmlFor="longSideLength">Long side length (px)</Label>
                <Input
                  {...getFieldProps('lengthLongSide')}
                  type="number"
                  id="longSideLength"
                />
                {errors.lengthLongSide && <span>{errors.lengthLongSide}</span>}
              </FormGroup>
            )}
          </>
        )}
        <FormGroup>
          <Button type="submit">Create</Button>
        </FormGroup>
      </FormLayout>
    </form>
  );
};
